/* The "+" button of a card's title row: 32px, 44px on coarse pointers. */
.button {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-muted);
  touch-action: manipulation;
}

.button:hover,
.button[aria-expanded='true'] {
  background: var(--surface-muted);
  color: var(--text);
}

.button:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: -1px;
}

.button svg {
  width: 18px;
  height: 18px;
}

@media (pointer: coarse) {
  .button {
    width: 44px;
    height: 44px;
  }
}

.panel {
  position: fixed;
  z-index: 60;
  box-sizing: border-box;
  max-width: calc(100vw - 16px);
  overflow-y: auto;
  padding: 12px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-pop);
  outline: none;
}

/* Inside the bottom sheet the panel is plain content. */
.inSheet {
  position: static;
  max-width: none;
  padding: 0;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

/* ---- form pieces shared by the forms inside the panel ---- */
.form {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.label {
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}

.input {
  box-sizing: border-box;
  width: 100%;
  min-height: 32px;
  padding: 5px 10px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-sm);
  background: var(--surface);
  font-size: var(--font-size);
}

.input[aria-invalid='true'] {
  border-color: var(--danger);
}

.input::placeholder {
  color: var(--text-muted);
}

.input:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: -1px;
}

.error {
  margin: 0;
  color: var(--danger);
  font-size: var(--font-size-sm);
}

.note {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

@media (pointer: coarse) {
  .input {
    min-height: 44px;
    /* 16px keeps iOS from zooming the page when the field takes focus. */
    font-size: 16px;
  }

  .actions button {
    min-height: 44px;
  }
}
